function getLang() {
    let fullPath = window.location.pathname.split('/');
    let cleanPath = fullPath.filter(Boolean);
    return cleanPath[0];
}

export default getLang;